export const TOKEN_EXPIRATION = 'TOKEN_EXPIRATION';
export const USER_SIGNOUT = 'USER_SIGNOUT';
export const EQUIFAX = 'Equifax';
export const OPEN_SGC = 'OpenSGC';

export const categories = {
  REGISTRACIONES: 'Registraciones',
  COBRANZAS: 'Cobranzas',
  ASESOR_ENERGETICO: 'Asesor energético',
  RECLAMOS: 'Reclamos',
  TRAMITES: 'Tramites',
  CONSULTAS: 'Consultas',
  FACTURACION: 'Facturación',
  CONTACTO: 'Contacto',
  DENUNCIAS: 'Denuncias',
  RECOMPENSAS: 'Recompensas',
  ENCUESTAS: 'Encuestas'
};

export const actions = {
  // Registracion
  PREGUNTAS_RELACION_CUENTA: 'Se respondieron correctamente preguntas de relación con cuenta',
  PREGUNTAS_RELACION_CUENTA_ERROR: 'Se respondieron incorrectamente preguntas de relación con cuenta',
  ASOCIAR_SUMINISTRO: 'Asociación de un suministro',
  ASOCIAR_SUMINISTRO_ERROR: 'Falló la asociación de un suministro',
  ASOCIAR_SUMINISTRO_RELACIONADO: 'Asociación de suministros relacionados',
  ASOCIAR_SUMINISTRO_RELACIONADO_ERROR: 'Falló la asociación de suministros relacionados',
  SOLICITAR_RECUPERO_CONTRASEÑA: 'Solicitud de email para recuperar contraseña',
  RECUPERAR_CONTRASEÑA: 'Recuperación de contraseña',
  CAMBIAR_CONTRASEÑA: 'Cambio de contraseña',
  REGISTRO_USUARIO: 'Registro de usuario',
  VALIDACION_USUARIO: 'Validación de nuevo usuario registrado',
  INICIO_SESION: 'Inicio de sesión',
  INICIO_SESION_INCORRECTO: 'Inicio de sesión incorrecto',
  CIERRE_SESION: 'Cierre de sesión',
  EXPIRACION_SESION: 'Expiración de sesión',
  PREGUNTAS_VALIDACION_IDENTIDAD: 'Validación de identidad correcta',
  PREGUNTAS_VALIDACION_IDENTIDAD_ERROR: 'Validación de identidad incorrecta',
  INGRESO_PREGUNTAS_VALIDACION_IDENTIDAD: 'Ingreso a preguntas de validación de identidad',
  DESVINCULAR_SUMINISTRO: 'Desasociación de suministro',
  SOLICITUD_CODIGO_VERIFICACION: 'Solicitud de código de verificación',

  // Cobranzas
  DESCARGA_CUPON_PAGO: 'Descarga de cupón de pago',
  DESCARGA_CUPON_PAGO_SIN_LOGIN: 'Descarga de cupón de pago sin login',
  DESCARGA_MASIVA_CUPON_PAGO: 'Descarga masiva de cupones de pago',
  GENERACION_PAGO: 'Generación de pago',
  GENERACION_PAGO_WHATSAPP: 'Generación de pago - Whatsapp',
  GENERACION_PAGO_ERRONEO: 'Error al pagar',
  GENERACION_PAGO_SIN_LOGIN: 'Generación de pago sin login',
  GENERACION_PAGO_ERRONEO_SIN_LOGIN: 'Error al pagar sin login',

  // Asesor energetico
  COMPARTIR_TIP: 'Compartir tip',
  MARCAR_TIP_FAVORITO: 'Activación tip favorito',
  DESMARCAR_TIP_FAVORITO: 'Desmarcar tip favorito',
  VISUALIZAR_TIPS: 'Visualización de tip',

  // Consulta
  CONSULTAR_TARIFA_SOCIAL: 'Consulta de tarifa social',
  CONSULTAR_TARIFA_SOCIAL_SIN_LOGIN: 'Consulta de tarifa social sin login',
  CONSULTA_SALDO: 'Consulta de saldo sin login',
  CONSULTA_ULTIMA_FACTURA: 'Consulta de última factura sin login',
  CONSULTA_NOTIFICACIONES: 'Consulta de notificaciones',

  // Reclamo
  CANCELAR_RECLAMO: 'Cancelación de reclamo',
  GENERACION_RECLAMO: 'Generación de reclamo',
  GENERACION_RECLAMO_ERRONEO: 'Error al generar un reclamos',
  GENERACION_RECLAMO_SIN_LOGIN: 'Generación de reclamo sin login',
  GENERACION_RECLAMO_ERRONEO_SIN_LOGIN: 'Error al generar un reclamo sin login',
  REITERAR_RECLAMO: 'Reiteración de reclamo',

  // Tramite
  CANCELAR_TRAMITE: 'Cancelación',
  GENERACION_TRAMITE: 'Generación',
  GENERACION_TRAMITE_ERRONEO: 'Error en generación',
  GENERACION_TRAMITE_SIN_LOGIN: 'Generación',
  GENERACION_TRAMITE_ERRONEO_SIN_LOGIN: 'Error en generación',
  REITERAR_TRAMITE: 'Reiteración',
  INICIO_ALTA_SUMINISTRO: 'Inicio de alta de suministro',
  INICIO_CAMBIO_TITULARIDAD: 'Inicio de cambio de titularidad',
  INICIO_BAJA_SUMINISTRO: 'Inicio de baja de suministro',
  INICIO_ALTA_SUMINISTRO_ERRONEO: 'Error al iniciar alta de suministro',
  INICIO_CAMBIO_TITULARIDAD_ERRONEO: 'Error al iniciar cambio de titularidad',
  INICIO_BAJA_SUMINISTRO_ERRONEO: 'Error al iniciar baja de suministro',
  CAMBIO_FECHA_VENCIMIENTO: 'Cambio de fecha de vencimiento',
  CAMBIO_FECHA_VENCIMIENTO_ERRONEO: 'Error al cambiar fecha de vencimiento',

  // Facturacion
  ADHESION_FACTURA_DIGITAL: 'Adhesión a factura digital',
  NO_ADHESION_FACTURA_DIGITAL: 'Se rechazan términos y condiciones de factura digital',
  DESCARGA_FACTURA: 'Descarga de factura',
  DESCARGA_FACTURA_ERROR: 'Falló la descarga de factura',
  DESCARGA_MASIVA_FACTURAS: 'Descarga masiva de facturas',
  DESCARGA_MASIVA_FACTURAS_ERROR: 'Falló la descarga masiva de facturas',

  // Contacto
  ACTUALIZACION_DATOS_USUARIO: 'Actualización de datos de usuario',
  ACTUALIZACION_DATOS_USUARIO_ERRONEO: 'Falló la actualización de datos de usuario',

  // Denuncia
  ENVIAR_FORMULARIO_DENUNCIA: 'Generación de denuncia -',
  ENVIAR_FORMULARIO_DENUNCIA_SIN_LOGIN: 'Generación de denuncia sin login -',
  ENVIAR_MAIL_DENUNCIA: 'Generación de denuncia -',
  LLAMAR_POR_DENUNCIA: 'Generación de denuncia -',

  // Recompensa
  CANJE_VOUCHER: 'Canje de voucher',

  // Encuesta
  DESPLIEGUE_DE_ENCUESTA: 'Despliegue de encuesta',
  GENERACION_DE_ENCUESTA: 'Generación de encuesta',
  ERROR_AL_GENERAR_ENCUESTA: 'Error al generar encuesta'
};

const subLabels = {
  FLUJO_OK: 'WDRG | Flujos | -OK- |',
  FLUJO_NOT_OK: 'WDRG | Flujos | -NOT OK- |',
  ADOPCION_OK: 'WDRG | Adopción | -OK- |',
  ADOPCION_NOT_OK: 'WDRG | Adopción | -NOT OK- |',
  USABILIDAD_OK: 'WDRG | Usabilidad | -OK- |',
  USABILIDAD_NOT_OK: 'WDRG | Usabilidad | -NOT_OK- |',
  VALOR_AGREGADO_OK: 'WDRG | Valor agregado | -OK- |',
  ERROR: 'WDRG | Error | -ERROR- |'
};

export const labels = {
  // Registraciones
  PREGUNTAS_RELACION_CUENTA_OK: subLabels.FLUJO_OK,
  PREGUNTAS_RELACION_CUENTA_NOT_OK: subLabels.FLUJO_NOT_OK,
  ASOCIAR_SUMINISTRO_OK: subLabels.FLUJO_OK,
  ASOCIAR_SUMINISTRO_ERROR: subLabels.ERROR,
  ASOCIAR_SUMINISTRO_RELACIONADO_OK: subLabels.FLUJO_OK,
  ASOCIAR_SUMINISTRO_RELACIONADO_ERROR: subLabels.ERROR,
  SOLICITAR_RECUPERO_CONTRASEÑA_OK: subLabels.FLUJO_OK,
  RECUPERAR_CONTRASEÑA_OK: subLabels.FLUJO_OK,
  CAMBIAR_CONTRASEÑA_OK: subLabels.FLUJO_OK,
  REGISTRO_USUARIO_OK: subLabels.ADOPCION_OK,
  VALIDACION_USUARIO_OK: subLabels.FLUJO_OK,
  INICIO_SESION_OK: subLabels.ADOPCION_OK,
  INICIO_SESION_INCORRECTO: `${subLabels.FLUJO_NOT_OK} Inicio de sesión incorrecto`,
  INICIO_SESION_INCORRECTO_CREDENCIALES: `${subLabels.FLUJO_NOT_OK} credenciales invalidas`,
  INICIO_SESION_INCORRECTO_NO_CONFIRMADO: `${subLabels.FLUJO_NOT_OK} email no confirmado`,
  INICIO_SESION_INCORRECTO_CONEXION: `${subLabels.FLUJO_NOT_OK} error de conexión`,
  CIERRE_SESION_OK: subLabels.FLUJO_OK,
  EXPIRACION_SESION_OK: subLabels.FLUJO_OK,
  PREGUNTAS_VALIDACION_IDENTIDAD_OK: subLabels.FLUJO_OK,
  PREGUNTAS_VALIDACION_IDENTIDAD_NOT_OK: subLabels.FLUJO_NOT_OK,
  INGRESO_PREGUNTAS_VALIDACION_IDENTIDAD_OPEN_SGC: `${subLabels.FLUJO_OK} Proveedor - OpenSGC`,
  INGRESO_PREGUNTAS_VALIDACION_IDENTIDAD_EQUIFAX: `${subLabels.FLUJO_OK} Proveedor - Equifax`,
  DESVINCULAR_SUMINISTRO_OK: subLabels.FLUJO_OK,
  SOLICITUD_CODIGO_VERIFICACION_OK: subLabels.FLUJO_OK,

  // Cobranzas
  DESCARGA_CUPON_PAGO_OK: subLabels.VALOR_AGREGADO_OK,
  DESCARGA_CUPON_PAGO_SIN_LOGIN_OK: subLabels.VALOR_AGREGADO_OK,
  DESCARGA_MASIVA_CUPON_PAGO_OK: subLabels.VALOR_AGREGADO_OK,
  GENERACION_PAGO_OK: subLabels.VALOR_AGREGADO_OK,
  GENERACION_PAGO_ERROR: subLabels.ERROR,
  GENERACION_PAGO_SIN_LOGIN_OK: subLabels.VALOR_AGREGADO_OK,
  GENERACION_PAGO_SIN_LOGIN_ERROR: subLabels.ERROR,

  // Asesor Energetico
  COMPARTIR_TIP_OK: subLabels.USABILIDAD_OK,
  MARCAR_TIP_FAVORITO_OK: subLabels.USABILIDAD_OK,
  DESMARCAR_TIP_FAVORITO_OK: subLabels.USABILIDAD_OK,
  VISUALIZAR_TIPS_OK: subLabels.USABILIDAD_OK,

  // Consultas
  CONSULTAR_TARIFA_SOCIAL_OK: subLabels.VALOR_AGREGADO_OK,
  CONSULTAR_TARIFA_SOCIAL_SIN_LOGIN_OK: subLabels.VALOR_AGREGADO_OK,
  CONSULTA_SALDO_OK: subLabels.VALOR_AGREGADO_OK,
  CONSULTA_ULTIMA_FACTURA_OK: subLabels.VALOR_AGREGADO_OK,
  CONSULTA_NOTIFICACIONES_OK: subLabels.USABILIDAD_OK,

  // Reclamos
  CANCELAR_RECLAMO_OK: subLabels.VALOR_AGREGADO_OK,
  GENERACION_RECLAMO_OK: subLabels.VALOR_AGREGADO_OK,
  GENERACION_RECLAMO_ERROR: subLabels.ERROR,
  GENERACION_RECLAMO_SIN_LOGIN_OK: subLabels.VALOR_AGREGADO_OK,
  GENERACION_RECLAMO_SIN_LOGIN_ERROR: subLabels.ERROR,
  REITERAR_RECLAMO_OK: subLabels.VALOR_AGREGADO_OK,

  // Tramites
  CANCELAR_TRAMITE_OK: subLabels.VALOR_AGREGADO_OK,
  GENERACION_TRAMITE_OK: subLabels.VALOR_AGREGADO_OK,
  GENERACION_TRAMITE_ERROR: subLabels.ERROR,
  GENERACION_TRAMITE_SIN_LOGIN_OK: subLabels.VALOR_AGREGADO_OK,
  GENERACION_TRAMITE_SIN_LOGIN_ERROR: subLabels.ERROR,
  REITERAR_TRAMITE_OK: subLabels.VALOR_AGREGADO_OK,
  INICIO_ALTA_SUMINISTRO_OK: subLabels.VALOR_AGREGADO_OK,
  INICIO_CAMBIO_TITULARIDAD_OK: subLabels.VALOR_AGREGADO_OK,
  INICIO_BAJA_SUMINISTRO_OK: subLabels.VALOR_AGREGADO_OK,
  INICIO_ALTA_SUMINISTRO_ERROR: subLabels.FLUJO_NOT_OK,
  INICIO_CAMBIO_TITULARIDAD_ERROR: subLabels.FLUJO_NOT_OK,
  INICIO_BAJA_SUMINISTRO_ERROR: subLabels.FLUJO_NOT_OK,
  CAMBIO_FECHA_VENCIMIENTO_OK: subLabels.VALOR_AGREGADO_OK,
  CAMBIO_FECHA_VENCIMIENTO_ERROR: subLabels.ERROR,

  // Facturacion
  ADHESION_FACTURA_DIGITAL_OK: subLabels.VALOR_AGREGADO_OK,
  NO_ADHESION_FACTURA_DIGITAL_OK: subLabels.FLUJO_NOT_OK,
  DESCARGA_FACTURA_OK: subLabels.VALOR_AGREGADO_OK,
  DESCARGA_FACTURA_ERROR: subLabels.ERROR,
  DESCARGA_MASIVA_FACTURAS_OK: subLabels.VALOR_AGREGADO_OK,
  DESCARGA_MASIVA_FACTURAS_ERROR: subLabels.ERROR,

  // Contacto
  ACTUALIZACION_DATOS_USUARIO_OK: subLabels.VALOR_AGREGADO_OK,
  ACTUALIZACION_DATOS_USUARIO_ERROR: subLabels.ERROR,

  // Denuncias
  ENVIAR_FORMULARIO_DENUNCIA_OK: subLabels.VALOR_AGREGADO_OK,
  ENVIAR_FORMULARIO_DENUNCIA_SIN_LOGIN_OK: subLabels.VALOR_AGREGADO_OK,
  ENVIAR_MAIL_DENUNCIA_OK: subLabels.VALOR_AGREGADO_OK,
  LLAMAR_POR_DENUNCIA_OK: subLabels.VALOR_AGREGADO_OK,

  // Recompensas
  CANJE_VOUCHER_OK: subLabels.USABILIDAD_OK
};
